<section class="container-fluid mt-5">
    <button class="btn btn-success" routerLink="/administradores/admin/eventos/lista/etapas/{{miId}}/localidades/{{idEtapa}}">Atras</button>

    
    <h1>Boletas del Evento {{miId}} en la localidad {{nombre}}</h1>
    <small>Boletas totales {{numeroDeBoletas}}</small> <br>
    <small>Boletas vendidas {{numeroDeBoletasVendidas}}</small> <br>
    <small>Boletas por vender {{numeroDeBoletasPorVender}}</small> <br>
    <small>Dinero Recaudado para entregar al organizador: {{dineroRecaudado|currency:'COP'}}</small> <br>
    <button class="btn btn-success" routerLink= "agregar"> Agregar Boletas</button>

    <table class="table mt-3">

        <thead>
            <tr>
                <th>Id</th>
                
                <th>seccion y silla</th>
                <th>Precio</th>
                <th>Vendida</th>
                <th>Utilizada</th>
                <th>Proceso</th>

                <th>Reservada</th>
                <th>Disponible</th>

                <th>Servicio</th>
                <th>IVA</th>
                <th>Localidad</th>
                <th>Proceso</th>
                <th>Reserva</th>
                <th>Disponible</th>
                <th>Vendido</th>
                <th>Borrar</th>
                
            </tr>
    
    
    
        </thead>
        <tbody>
          
            <tr *ngFor = "let boleta of boletas">
                <td>{{boleta?.id}}</td>
                
                <td>{{boleta?.seccionSilla}}</td>
                <td>{{boleta?.precio | currency: 'COP'}}</td>

                <td>{{boleta?.vendida |booleans}}</td>

                <td>{{boleta?.utilizada |booleans}}</td>
                <td>{{boleta?.reservado|booleans}}</td>
                <td>{{boleta?.reserva|booleans}}</td>
                <td>{{boleta?.disponible|booleans}}</td>

                <td>{{boleta?.servicio | currency:'COP'}}</td>
                <td>{{boleta?.servicioIva | currency:'COP'}}</td>
                <td>{{boleta?.localidadNombre}}</td>
                
                <td><button class="btn btn-warning" (click)="cambiarReservado(boleta)"> Proceso</button></td>
                <td><button class="btn btn-warning" (click)="cambiarReserva(boleta)"> Reservado</button></td>
                <td><button class="btn btn-warning" (click)="cambiarDisponible(boleta)"> Disponible</button></td>
                <td><button class="btn btn-warning" (click)="cambiarVendido(boleta)"> Vendido</button></td>
                <td><button  class="btn btn-danger" (click)="borrarBoleta(boleta?.id)"> Delete</button></td>
    
            </tr>
    
    
        </tbody>
    
    </table>
    
</section>